import { useEffect, useState } from "react";


import {
  datetime2String,
  getRandomId,
} from "../../../utils/utils";

export default function useWallboxDemoData() {
  const [wallbox, setWallbox] = useState({
    id: 0,
    lockable: true,
    hybrid_charging_compatible: true,
    surplus_charging_compatible: true,
    _lock_times: [],
    _set_point: {
      locked: false,
      surplus_charging: true,
      hybrid_charging_current: null,
    },
    _state: {
      consumption: 9
    }
  });

  useEffect(() => {
    const consumption = (
      wallbox._set_point.locked
        ? 0
        : (!wallbox._set_point.surplus_charging
          ? 11.05
          : (wallbox._set_point.hybrid_charging_current
            ? Math.max(9, wallbox._set_point.hybrid_charging_current * 230 * 3 / 1000)
            : 9))
    )
    if (wallbox._state.consumption !== consumption) setWallbox(w => ({ ...w, _state: { ...w._state, consumption } }))
  }, [wallbox])

  const setLocked = (locked) => setWallbox((w) => ({
    ...w,
    _set_point: { ...w._set_point, locked },
  }))

  const setHybridCharging = (hybridChargingCurrent) => setWallbox((w) => ({
    ...w,
    _set_point: {
      ...w._set_point,
      hybrid_charging_current: hybridChargingCurrent,
    },
  }))

  const setSurplusCharging = (surplusCharging) =>
    setWallbox((w) => ({
      ...w,
      _set_point: { ...w._set_point, surplus_charging: surplusCharging },
    }))

  const addLockTime = (locked, datetime) =>
    setWallbox((w) => ({
      ...w,
      _lock_times: [
        ...w._lock_times,
        {
          id: getRandomId(),
          locked,
          datetime: datetime2String(datetime),
        },
      ],
    }))

  const deleteLockTime = (lockTime) =>
    setWallbox((w) => ({
      ...w,
      _lock_times: w._lock_times.filter(
        (l) => l.id !== lockTime.id
      ),
    }))



  return {
    wallbox,
    setLocked,
    setHybridCharging,
    setSurplusCharging,
    addLockTime,
    deleteLockTime,
    chargingHistory: [
      { id: 1, start_time: '2025-01-01 09:06:00', end_time: '2025-01-01 10:14:00', duration: '01:08', 'energy': 10.8 }
    ]
  }


}